import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TradeAssetState } from './trade-asset.state';
import { tradeAssetFeatureKey } from './trade-asset.reducers';

export const selectTradeAssetState = createFeatureSelector<TradeAssetState>(tradeAssetFeatureKey);

export const selectTradeAsset = createSelector(selectTradeAssetState, (state: TradeAssetState) => state);